import React from "react";

import { trioMarkets, getTrioExposure, bookClass } from "./trioMarkets";

const isSuspended = (item) => String(item?.gstatus || "").toUpperCase() !== "OPEN";

/**
 * BetTableTrio — Trio (casino/trio, .casino-table.pasa) bet table in the reference markup.
 * Renders the inner `.casino-detail`:
 *   .row.row5 > .col-12.col-md-6 (Session: lay/back with bhav) + 2 × .col-6.col-md-3.pasa-fancy (1 2 4 / J Q K)
 *   .row.row5.mt-2.pasa-cards > 4 × .col-6.col-md-3 (Two Red/Black/Odd/Even Only)
 *   .casino-box-row.pasa-other-bets > 5 × .casino-box-row.pasa-other-bet (back only)
 * Styled by the ported reference rules (.pasa … in index.css).
 */
export default function BetTableTrio({ data = [], onBetClick, exposures = {} }) {
  const m = trioMarkets(data);

  const click = (item, type) => {
    const value = type === "lay" ? item?.l : item?.b;
    if (isSuspended(item) || !value) return;
    onBetClick?.(value, item?.nat, type, item);
  };

  const book = (item) => getTrioExposure(exposures, item?.nat);

  const blCell = (item, type) => (
    <div
      className={`${type} casino-bl-box-item${isSuspended(item) ? " suspended" : ""}`}
      onClick={() => click(item, type)}
    >
      <span className="casino-box-odd">{type === "lay" ? item?.l : item?.b}</span>
    </div>
  );

  const fancyBox = (item, withLay = true) => {
    const amt = book(item);
    return (
      <>
        <div className="casino-nation-name">
          <b>{item?.nat}</b>
        </div>{" "}
        <div className="casino-bl-box">
          {blCell(item, "back")}
          {withLay && " "}
          {withLay && blCell(item, "lay")}
        </div>{" "}
        <div className={`casino-nation-name ${bookClass(amt)}`}>{amt}</div>
      </>
    );
  };

  const s = m.trio;
  const sAmt = book(s);

  return (
    <div className="casino-detail">
      <div className="row row5">
        <div className="col-12 col-md-6">
          <div className="casino-box-row d-none-small" style={{ height: "30px" }} />{" "}
          <div className="casino-box-row pasa-sesssion">
            <div className="casino-nation-name">
              <b className="pointer">{s?.nat}</b>{" "}
              <div className="float-right">
                <span className={`mr-2 ${bookClass(sAmt)}`}>{sAmt}</span>
              </div>
            </div>{" "}
            <div className="casino-bl-box">
              <div
                className={`lay casino-bl-box-item${isSuspended(s) ? " suspended" : ""}`}
                onClick={() => click(s, "lay")}
              >
                <span>{s?.l}</span> <span className="casino-box-odd">{s?.lbhav}</span>
              </div>{" "}
              <div
                className={`back casino-bl-box-item${isSuspended(s) ? " suspended" : ""}`}
                onClick={() => click(s, "back")}
              >
                <span>{s?.b}</span> <span className="casino-box-odd">{s?.bbhav}</span>
              </div>
            </div>
          </div>{" "}
          <div className="casino-box-row d-none-small" style={{ height: "30px" }} />
        </div>{" "}
        <div className="col-6 col-md-3 pasa-fancy">
          <div className="casino-box-row">{fancyBox(m.section124)}</div>
        </div>{" "}
        <div className="col-6 col-md-3 pasa-fancy">
          <div className="casino-box-row">{fancyBox(m.jqk1)}</div>
        </div>
      </div>{" "}
      <div className="row row5 mt-2 pasa-cards">
        {[m.red2, m.black2, m.odd2, m.even2].map((item, i) => (
          <React.Fragment key={i}>
            {i > 0 && " "}
            <div className="col-6 col-md-3">
              <div className="casino-box-row">{fancyBox(item)}</div>
            </div>
          </React.Fragment>
        ))}
      </div>{" "}
      <div className="casino-box-row pasa-other-bets">
        {[m.pair2, m.flush, m.straight, m.trio1, m.straightflush].map((item, i) => (
          <React.Fragment key={i}>
            {i > 0 && " "}
            <div className="casino-box-row pasa-other-bet">{fancyBox(item, false)}</div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
